import GenericListTab from "./../../../factories/generic-list-tab";
import * as ko from "knockout";
class EventScriptChecklistTab extends GenericListTab {
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
}
export default EventScriptChecklistTab;